class StaticSingleton<T> {
    private instance: StaticSingleton<T>;

    constructor() {
        if (!this.instance) {
            this.instance = this;
        }
        
        return this.instance;
    }
}

export default StaticSingleton;
